module.exports = __webpack_public_path__ + "img/jisukuai3_icon.d0d54c57.png";